import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isLargeWithOthers, isOnlyLarge } from "../CardDiscount/CardDiscount.styles";
export var rootSmStyles = {
  gridArea: 'vlp'
};
export var rootLgStyles = {
  gridArea: 'img',
  maxWidth: '90px'
};
export var rootLgMediaStyles = {
  '@media screen and (min-width: 1024px)': rootLgStyles
};
export var getSizedRootStyles = function getSizedRootStyles(sizes) {
  if (isOnlyLarge(sizes)) return rootLgStyles;
  if (isLargeWithOthers(sizes)) return _objectSpread(_objectSpread({}, rootSmStyles), rootLgMediaStyles);
  return rootSmStyles;
};

// praxis
export var praxisSmStyles = {};
export var praxisLgStyles = {
  flexDirection: 'column',
  width: '64px',
  justifyContent: 'center'
};
export var praxisLgMediaStyles = {
  '@media screen and (min-width: 1024px)': praxisLgStyles
};
export var getSizedPraxisStyles = function getSizedPraxisStyles(sizes) {
  if (isOnlyLarge(sizes)) return praxisLgStyles;
  if (isLargeWithOthers(sizes)) return _objectSpread(_objectSpread({}, praxisSmStyles), praxisLgMediaStyles);
  return praxisSmStyles;
};

// brico
export var bricoSmStyles = {};
export var bricoLgStyles = function bricoLgStyles(variant) {
  return _objectSpread({
    minWidth: '120px',
    height: '42px',
    alignItems: 'center',
    alignContent: 'center'
  }, variant !== 'fr' && {
    '& > p:first-of-type': {
      width: '100%',
      textAlign: 'center'
    }
  });
};
export var bricoLgMediaStyles = function bricoLgMediaStyles(variant) {
  return {
    '@media screen and (min-width: 1024px)': bricoLgStyles(variant)
  };
};
export var getSizedBricoStyles = function getSizedBricoStyles(sizes, variant) {
  if (isOnlyLarge(sizes)) return bricoLgStyles(variant);
  if (isLargeWithOthers(sizes)) return _objectSpread(_objectSpread({}, bricoSmStyles), bricoLgMediaStyles(variant));
  return bricoSmStyles;
};